/**
 * GENERATED by scripts/generate-board-steps.ts from the committed docs/living/planner-magic-canvas/Home.dc.html — DO NOT EDIT.
 * Regenerate with `npm run board:generate`; `server/__tests__/home-board-parity.test.ts` fails when this file and the board disagree.
 */

export const HOME_BOARD = {
  "tabs": [
    {
      "label": "Planner",
      "tag": "",
      "icon": "M9 4h6M9 4a1 1 0 0 0-1 1v1h8V5a1 1 0 0 0-1-1M8 6H6a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2M9 12h6M9 16h4"
    },
    {
      "label": "Executor",
      "tag": "preview",
      "icon": "M9 11l2 2 4-4M4 5h16v14H4z"
    }
  ],
  "actions": [
    {
      "label": "Save or print",
      "icon": "M6 9V3h12v6M6 18H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2M6 14h12v7H6z"
    },
    {
      "label": "Review",
      "icon": "M21 12a9 9 0 1 1-3-6.7M21 4v5h-5"
    },
    {
      "label": "Who can see this",
      "icon": "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    }
  ],
  "chapters": [
    {
      "number": 1,
      "title": "You and your people",
      "screens": [
        "Personal details",
        "Children and dependants",
        "Children’s daily needs",
        "Marital status",
        "Pets",
        "Who your executor is",
        "Beneficiaries",
        "Military or RCMP service",
        "Government ID"
      ]
    },
    {
      "number": 2,
      "title": "What you own",
      "screens": [
        "Home and property",
        "Vehicles",
        "Valuables",
        "Firearms",
        "Safes"
      ]
    },
    {
      "number": 3,
      "title": "Work",
      "screens": [
        "Your job",
        "Benefits from work",
        "Past employers"
      ]
    },
    {
      "number": 4,
      "title": "Money and insurance",
      "screens": [
        "Banks",
        "Investments",
        "Income",
        "Insurance",
        "Taxes",
        "Debts",
        "Bills"
      ]
    },
    {
      "number": 5,
      "title": "Legal and documents",
      "screens": [
        "Your will",
        "Powers of attorney",
        "Other legal papers",
        "Where your papers are",
        "Business papers",
        "Your professionals"
      ]
    },
    {
      "number": 6,
      "title": "Your wishes",
      "screens": [
        "Burial or cremation",
        "Who makes the calls",
        "People to tell",
        "The send-off",
        "Letters",
        "A message to your executor"
      ]
    }
  ],
  "touches": [
    {
      "id": "willchk",
      "title": "Check your will against your plan"
    },
    {
      "id": "uploads",
      "title": "Uploads"
    },
    {
      "id": "letters",
      "title": "Your letters"
    },
    {
      "id": "bills",
      "title": "Check your bills against your statements"
    },
    {
      "id": "online",
      "title": "Your online life"
    }
  ],
  "labels": {
    "home": "Home",
    "where": "Where things are",
    "contacts": "Contacts",
    "fin": "Financial summary",
    "meet": "Family meeting",
    "settings": "Settings",
    "chapter-2": "Chapter two"
  },
  "backLabel": "Return to {label}",
  "needs": {
    "title": "What your executor still needs",
    "sub": "{n} questions to answer · {dos} things only you can do. The ones that cost {executor} most come first. Answer right here — it saves as you go.",
    "all": "All {n} ›",
    "act": "Open the page ›"
  },
  "previewText": "Preview. This is what {executor} gets once your death is confirmed. Nothing here can be started before then.",
  "settings": [
    {
      "name": "Account",
      "sub": "your sign-in",
      "rows": [
        "Email",
        "Password",
        "Delete my account"
      ]
    },
    {
      "name": "Security",
      "sub": "how you get in, and what is protected",
      "rows": [
        "Two-step sign-in",
        "Your recovery code",
        "Where you are signed in",
        "Who can see your plan",
        "Where your codes are kept"
      ]
    },
    {
      "name": "Notifications",
      "sub": "what we send you",
      "rows": [
        "Emails about your plan",
        "Yearly reminder to review",
        "Check what we read from an upload before saving"
      ]
    },
    {
      "name": "More plan settings",
      "sub": "until each has its own home in your plan",
      "rows": [
        "Your situation",
        "Where you live",
        "After a death is reported",
        "A message to your executor",
        "Your secure file",
        "Your advisor"
      ]
    }
  ],
  "ownList": {
    "rows": [
      {
        "key": "sign",
        "rank": 1,
        "group": "Hand-overs",
        "label": "Sign your will — it is still a draft",
        "why": "Until it is signed, Ontario’s rules decide who inherits and who may act",
        "clears": "",
        "exFact": "{planner}’s will is a draft — it was never signed",
        "exOff": "",
        "hand": false,
        "waitsForAccept": false,
        "page": ""
      },
      {
        "key": "hkey",
        "rank": 6,
        "group": "Hand-overs",
        "label": "Give {executor} a copy of the house key",
        "why": "{executor} has to get in on the first day",
        "clears": "",
        "exFact": "{planner} may not have given you a house key",
        "exOff": "A house key for you",
        "hand": true,
        "waitsForAccept": false,
        "page": ""
      },
      {
        "key": "ckey",
        "rank": 7,
        "group": "Hand-overs",
        "label": "Give {executor} a key to the cottage",
        "why": "One trip fewer on the first day",
        "clears": "",
        "exFact": "{planner} may not have given you a cottage key",
        "exOff": "A cottage key for you",
        "hand": true,
        "waitsForAccept": false,
        "page": ""
      },
      {
        "key": "print",
        "rank": 8,
        "group": "Hand-overs",
        "label": "Print your plan — codes included — and keep it with your will",
        "why": "Paper needs no password. The date on each page says which copy is newest",
        "clears": "",
        "exFact": "",
        "exOff": "A printed copy of the plan kept with the will",
        "hand": true,
        "waitsForAccept": false,
        "page": "printplan"
      },
      {
        "key": "rpage",
        "rank": 9,
        "group": "Hand-overs",
        "label": "Print your recovery code page and keep it with your will",
        "why": "It opens your locked plan without {executor} and without a certificate",
        "clears": "",
        "exFact": "",
        "exOff": "A printed recovery code page kept with the will",
        "hand": true,
        "waitsForAccept": true,
        "page": "saverc"
      },
      {
        "key": "meet",
        "rank": 10,
        "group": "Hand-overs",
        "label": "Sit down with {executor} and the family and walk through your wishes",
        "why": "The one conversation that makes the first week easier — the meeting sheet is under Across your plan",
        "clears": "",
        "exFact": "",
        "exOff": "A family meeting about {planner}’s wishes",
        "hand": true,
        "waitsForAccept": false,
        "page": "meeting"
      },
      {
        "key": "make",
        "rank": 1,
        "group": "Hand-overs",
        "label": "Make a will — you don’t have one yet",
        "why": "Without one, Ontario’s rules decide who inherits and who may act",
        "clears": "Clears when you add your will",
        "exFact": "{planner} did not make a will",
        "exOff": "",
        "hand": false,
        "waitsForAccept": false,
        "page": ""
      },
      {
        "key": "orig",
        "rank": 3,
        "group": "Hand-overs",
        "label": "Find the signed original of your will",
        "why": "{executor} needs the original, not a copy, to apply to the court",
        "clears": "Clears when you say where it is",
        "exFact": "{planner} did not say where the signed original of the will is",
        "exOff": "",
        "hand": false,
        "waitsForAccept": false,
        "page": ""
      },
      {
        "key": "tell",
        "rank": 4,
        "group": "Hand-overs",
        "label": "Ask {executor} to be your executor",
        "why": "An executor who hasn’t been asked can’t say yes",
        "clears": "Clears when {executor} accepts",
        "exFact": "{planner} had not asked you ahead of time to be the executor",
        "exOff": "",
        "hand": false,
        "waitsForAccept": false,
        "page": ""
      },
      {
        "key": "tellbk",
        "rank": 5,
        "group": "Legal and documents · Your will",
        "label": "Ask {backup} to be your backup executor",
        "why": "A backup who hasn’t been asked can’t say yes",
        "clears": "Clears when {backup} accepts",
        "exFact": "{planner} had not asked you ahead of time to be the backup executor",
        "exOff": "",
        "hand": false,
        "waitsForAccept": false,
        "page": ""
      }
    ],
    "handoversSub": "Things to put in {executor}’s hands, or do together, so the first days go smoothly. Tick Done when it’s done, or skip what doesn’t apply.",
    "barWord": "done on your plan",
    "planSub": "Your plan has {total} things: {questions} questions to answer and {dos} things only you can do, like giving {executor} the house key. You’ve done {done} of them.",
    "execWord": "{executor}’s tasks that already have what they need",
    "execSub": "A task is ready once your plan holds what {executor} needs for it. For example, “File the final tax return” is ready once you’ve said who does your taxes.",
    "skipWord": "Skip",
    "undoSkipWord": "Undo skip"
  },
  "answers": {
    "lastUpdated": {
      "group": "Legal and documents · Your will",
      "label": "When did you last update your will?",
      "why": "A will more than 5 years old may not reflect who is in your life now",
      "ph": "Choose…",
      "opts": [
        "Within the last year",
        "1–3 years ago",
        "3–5 years ago",
        "More than 5 years ago",
        "Not sure"
      ]
    },
    "backup": {
      "group": "Legal and documents · Your will",
      "label": "Name a backup executor",
      "why": "Someone who acts if your executor can’t. Update your will to name them; a name here also nudges the update.",
      "ph": "Their name — or Not for me",
      "cardKind": "Backup executor"
    },
    "willPlace": {
      "title": "Where is the signed original kept?",
      "hint": "The whole address if it is not at home — a room, a box, a safety deposit, whichever it is. {executor} needs enough to find it."
    },
    "carPapers": {
      "label": "Where the car’s papers are",
      "why": "Selling or transferring the car waits on them",
      "ph": "Where the ownership and insurance slip are",
      "title": "Where are the car’s papers kept?",
      "hint": "The ownership and the insurance slip — and where any copies are. {executor} needs both to sell or transfer the car."
    },
    "accountant": {
      "cardKind": "Accountant"
    },
    "cancelWord": "Cancel",
    "saveWord": "Save"
  },
  "where": {
    "from": "Across your plan",
    "title": "Where things are",
    "note": "Every place you told us something is kept, in one list. Change a place on its own page.",
    "search": "Search the places — a key, a document, a room…",
    "gapsSwitch": "Only what is missing",
    "heads": [
      "What",
      "Which one",
      "Where it is"
    ],
    "notAnswered": "Not answered yet",
    "exNotSaid": "{planner} did not say",
    "boxPrompt": "Say where it is, and anything they need to get to it.",
    "savedTo": "Saved to {trail}",
    "keptHere": "Kept here, in your plan",
    "openPage": "Open the page instead ›",
    "act": {
      "answer": "Answer",
      "change": "Change here",
      "close": "Close"
    },
    "done": "Done",
    "empty": "Nothing matches.",
    "noPage": {
      "name": "Things on no page",
      "sub": "kept here, in your plan — change them on this page"
    },
    "add": {
      "open": "+ Add something — a key, a car, a document",
      "title": "What are you adding?",
      "line": "Most things already have a page. Pick it and add it there, so your executor gets everything that page asks for. You come straight back here after, and it shows in this list.",
      "close": "Close",
      "label": "What is it?",
      "choose": "Choose…",
      "addedHere": "Added here",
      "kinds": [
        {
          "label": "A key",
          "where": "Added here"
        },
        {
          "label": "A document or paper",
          "where": "Where your papers are"
        },
        {
          "label": "A vehicle",
          "where": "Vehicles"
        },
        {
          "label": "Jewellery, art or other valuables",
          "where": "Valuables"
        },
        {
          "label": "A firearm",
          "where": "Firearms"
        },
        {
          "label": "A safe or deposit box",
          "where": "Safes"
        },
        {
          "label": "A property",
          "where": "Home and property"
        },
        {
          "label": "A computer, phone or device",
          "where": "Added here"
        },
        {
          "label": "Something else",
          "where": "Added here"
        }
      ]
    },
    "newThing": "Something else",
    "showAll": "Show all of it",
    "clearSearch": "Clear the search"
  },
  "contacts": {
    "from": "Across your plan",
    "title": "Contacts",
    "note": "Everyone you named, once each, with every part they play. Copy an email or a number with one click.",
    "exNote": "Everyone {planner} named, once each, with every part they play.",
    "exFrom": "Settle the estate",
    "search": "Search people — a name, a firm, an email…",
    "chips": [
      {
        "id": "all",
        "label": "Everyone"
      },
      {
        "id": "family",
        "label": "Family"
      },
      {
        "id": "helpers",
        "label": "Executor and helpers"
      },
      {
        "id": "pros",
        "label": "Professionals"
      },
      {
        "id": "biz",
        "label": "Business"
      },
      {
        "id": "companies",
        "label": "Companies"
      }
    ],
    "heads": [
      "Who",
      "What they are to you",
      "Email",
      "Phone"
    ],
    "sort": {
      "title": "Sort by name",
      "az": "A to Z",
      "za": "Z to A"
    },
    "open": {
      "title": "Open the contact card"
    },
    "roles": {
      "more": "+{n} more",
      "fewer": "Fewer"
    },
    "copy": {
      "title": "Copy",
      "address": "Copy the address"
    },
    "blank": "—",
    "tick": {
      "all": "Tick everyone shown",
      "one": "Tick to download or send"
    },
    "download": {
      "label": "Download",
      "ticked": "The {n} you ticked",
      "shown": "Everyone shown ({n})",
      "items": [
        {
          "label": "Spreadsheet",
          "note": "Opens in Excel, Numbers or Google Sheets"
        },
        {
          "label": "Contacts to my computer",
          "note": "For Outlook, or Google or iCloud contacts"
        },
        {
          "label": "Contacts to my phone",
          "note": "We text a link to your phone. Tap it to add them."
        }
      ]
    },
    "toPhone": {
      "label": "Text to my phone",
      "sent": "Sent — check your texts"
    },
    "card": {
      "title": "Contact card — {name}",
      "note": "One record: a change here shows on every page {name} appears on",
      "person": {
        "name": "Name",
        "phone": "Mobile",
        "email": "Email",
        "phonePh": "Mobile number",
        "emailPh": "me@example.com"
      },
      "company": {
        "name": "Company name",
        "phone": "Main phone",
        "email": "Email or website",
        "phonePh": "Main number",
        "emailPh": "info@company.ca or company.ca"
      },
      "address": "Address",
      "addressPh": "Street, city, postal code",
      "askFor": "A person to ask for",
      "nobodyNamed": "Nobody named",
      "done": "Done"
    }
  }
} as const;
